// Libs
import Vue from "vue";
import VeeValidate from "vee-validate";
import cssVars from "css-vars-ponyfill";
import "@fancyapps/fancybox";
import "@fancyapps/fancybox/src/css/core.css";

// глобальная регистрация базовых компонентов
import "@/components/_globals";

// Components
import App from "./App.vue";

// Plugins
import vuetify from "@/plugins/vuetify";
import themes from "@/plugins/themes";

// Router
import router from "@/pages/article/router/router";

// Store
import store from "./store/store";

// Mixins
import Mess from "@/mixins/Mess";
import Locale from "@/mixins/Locale";

// Utils
import { getTheme } from "@/utils/get-theme";
import detectBrowser from "@/utils/detect-browser";
import changeTheme from "@/__dev_utils__/change-theme";

if (detectBrowser() === "ie") {
  document.body.classList.add("browser-ie");
  cssVars();
}

Vue.use(VeeValidate);
Vue.mixin(Mess);
Vue.mixin(Locale);

Vue.config.productionTip = false;

new Vue({
  vuetify,
  store,
  router,
  created() {
    this.$vuetify.theme.themes.light = getTheme(window.theme, themes);

    if (process.env.NODE_ENV === "development") {
      window._changeTheme = theme => {
        changeTheme(theme);
        this.$vuetify.theme.themes.light = getTheme(theme, themes);
      };
    }
  },
  render: h => h(App)
}).$mount("#app");
